export default __webpack_public_path__ + "icon_build_your_own.abf4aca9f34ef3e3a59fb3da71268307.svg";